
import { computed, defineComponent, reactive, ref, toRefs, watch } from 'vue';
import InputForm from '@/common/components/form/InputForm.vue';
import AppButton from '@/common/components/AppButton.vue';
import CheckboxElement from '@/common/elements/form/CheckboxElement.vue';
import PasswordRating from '@/learn-login/views/PasswordRating.vue';
import { isPhoneNumberValid } from '@/common/modules/phone';
import { useI18n } from 'vue-i18n';
import LocalesDropdown from '@/common/components/LocalesDropdown.vue';
import { Locale } from '@/common/i18n/locale';
import useApi from '@/common/modules/api';

interface ChoosePasswordPayload {
  phone: string;
  firstname: string;
  password: string;
  passwordConfirmation: string;
  rememberMe: boolean;
}

export default defineComponent({
  name: 'TemporaryExhibitionRegister',
  components: {
    LocalesDropdown,
    InputForm,
    AppButton,
    CheckboxElement,
    PasswordRating,
  },
  setup() {
    const { t } = useI18n();

    const showLocales = ref(false);
    const { locale } = useI18n();
    const localeFormRef = ref<HTMLFormElement>();

    const { post, data } = useApi('api/user/change-locale');

    watch(data, () => {
      redirect(data.value);
    });

    function changeLocale(locale: Locale) {
      post({ locale, targetPath: window.location.pathname });
    }

    function redirect(url: string) {
      if (data.value) {
        window.location.replace(url);
      }
    }

    const payload = reactive<ChoosePasswordPayload>({
      phone: '+41',
      firstname: '',
      password: '',
      passwordConfirmation: '',
      rememberMe: true,
    });

    const canSubmit = computed(
      () =>
        payload.phone &&
        !invalidPhoneNumberMessage.value &&
        payload.firstname &&
        payload.password === payload.passwordConfirmation &&
        payload.password !== '' &&
        payload.passwordConfirmation !== '',
    );

    const showPasswordsNotMatching = computed(
      () => payload.password !== '' && payload.passwordConfirmation !== '' && payload.password !== payload.passwordConfirmation,
    );

    const invalidPhoneNumberMessage = computed(() => {
      if (!payload.phone) {
        return null;
      }
      return !isPhoneNumberValid(payload.phone) ? t('form.phone.invalidFormat') : null;
    });

    return {
      canSubmit,
      showPasswordsNotMatching,
      invalidPhoneNumberMessage,
      showLocales,
      localeFormRef,
      locale,
      changeLocale,
      hasGeneralError: new URLSearchParams(window.location.search).has('error'),
      ...toRefs(payload),
    };
  },
});
